import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Label from 'LuxKit/Label'
import { getCanViewLuxPlusBenefits, getIsLuxPlusLPPEnabled } from 'luxPlus/selectors/featureToggle'
import React, { MouseEventHandler, useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import LuxPlusBenefitsModal from './modals/LuxPlusBenefitsModal'
import LuxPlusLabelContext from 'contexts/LuxPlusLabelContext'
import { useAppSelector } from 'hooks/reduxHooks'
import LuxPlusLogo from './Logos/LuxPlusLogo'
import FormatCurrency from '../../client/components/Common/FormatCurrency'

interface Props {
  offerPrice: number
  offerMemberPrice: number
  hasLuxPlusRate?: boolean
  hideUpsellModal?: boolean
  offer: App.BedbankOffer | App.BedbankOfferSummary
  savingAmount?: number
}

function LuxLPPPricingLabel({
  offerPrice,
  offerMemberPrice,
  hasLuxPlusRate,
  offer,
  savingAmount,
}: Props) {
  const showModal = useContext(ModalContext)
  const providerPage = useContext(LuxPlusLabelContext)
  const luxPlusLPPEnabled = useAppSelector(getIsLuxPlusLPPEnabled)
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)

  const toggleModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    const saveAmount = offerPrice - offerMemberPrice
    showModal(<LuxPlusBenefitsModal
      type="member-price-offer-lpp-no-save-amount"
      saveAmount={saveAmount}
      offer={offer}
      providerPage={providerPage}
    />)
  }, [offer, offerMemberPrice, offerPrice, providerPage, showModal])

  if (!luxPlusLPPEnabled || !hasLuxPlusRate) return null

  const label = (
    <Label
      kind="primary"
      variant="lux-plus"
      endIcon={!canViewLuxPlusBenefits ? <LineInfoCircleIcon /> : undefined}
    >
      {savingAmount ?
          <>Save <FormatCurrency format="roundedDollar" value={savingAmount} /> with <LuxPlusLogo colour="inherit" height={10} /></> :
          <>Member discounts with <LuxPlusLogo colour="inherit" height={10} /></>}
    </Label>
  )

  if (!canViewLuxPlusBenefits) return <Clickable onClick={toggleModal}>{label}</Clickable>

  return label
}

export default LuxLPPPricingLabel
